import { useContext, useEffect } from "react"
import { useLocation, useNavigate } from 'react-router-dom';
import { AuthContext } from "../contexts/AuthContext";
import Swal from 'sweetalert2';


export const DigitalSignature = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { onLogin } = useContext(AuthContext);


    useEffect(() => {
        const query = new URLSearchParams(location.search);

        const queryParams = {};

        for (const [key, value] of query) {
            queryParams[key] = value;
        }
      
        if (queryParams.secondRole && queryParams.secondRole != 'Parent') {
            Swal.fire({
                title: "Внимание !",
                icon: "warning",
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Напред",
                html:
                    `<div style="display: flex; align-items: center; justify-content: left; flex-wrap:wrap; width: 100%;">
                    <p style="width:100%;  font-weight: bold;">Вие сте с повече от енда роля в системата.</p>
                    <p style="width:100%;  font-weight: bold;">Моля, изберете модула, който искате да използвате.</p>
                    <div style="display: flex; align-items: center; gap: 5px; width:100%;">
                        <input type="radio" id="public" name="moduleType" value="1" checked>
                        <label for="public">Публичен</label>
                    </div>
                    <div style="display: flex; align-items: center; gap: 5px; width:100%;">
                        <input type="radio" id="private" name="moduleType" value="2">
                        <label for="private">Директорски</label>
                    </div>
                </div>`,
            }).then((result) => {
                if (result.isConfirmed) {
                    const selectedMethod = document.querySelector('input[name="moduleType"]:checked').value;

                    if (selectedMethod == 1) { //Влиза в родителския модул
                        if (queryParams.role != 'Parent') {
                            queryParams.secondRole = queryParams.role
                            queryParams.role = 'Parent';
                        }

                        onLogin(queryParams);

                        navigate('/parent/');
                    } else if (selectedMethod == 2) { //Влиза в директорския/администраторския модул

                        //Прави главната роля да е различната от родител, за да може да работи в директорския/администраторския модул с другата роля(Админ, Супер Админ, Директор, Община)
                        if (queryParams.role == 'Parent') {
                            queryParams.role = queryParams.secondRole;
                            queryParams.secondRole = 'Parent'
                        }

                        let school = null;

                        if (queryParams.school && queryParams.role == 'Director') {
                            try {
                                const parsedSchool = JSON.parse(queryParams.school);
                                school = {
                                    id: parsedSchool.Id,
                                    name: parsedSchool.Name,
                                    shortName: parsedSchool.ShortName
                                };
                            } catch (e) {
                                console.error('Error parsing school data:', e);
                            }
                        }


                        onLogin({ ...queryParams, school: school });
                        navigate('/schadm/');
                    }
                }
            });

        } else {
            if (queryParams.role == 'Parent') {
                onLogin(queryParams);

                navigate('/parent/');
            } else if (queryParams.role == 'SuperAdmin' || queryParams.role == 'Admin'
                || queryParams.role == 'Director' || queryParams.role == 'Municipality') {
                let school = null;

                if (queryParams.school && queryParams.role == 'Director') {
                    try {
                        const parsedSchool = JSON.parse(queryParams.school);
                        school = {
                            id: parsedSchool.Id,
                            name: parsedSchool.Name,
                            shortName: parsedSchool.ShortName
                        };
                    } catch (e) {
                        console.error('Error parsing school data:', e);
                    }
                }

                onLogin({ ...queryParams, school: school });
                navigate('/schadm/');
            } else {
                navigate('/parent-login')
            }
        }
    })

    return (null)
}